export default {
    localizationScreenSizes: []
}
